module.exports = __webpack_public_path__ + "static/media/logoYt.476825d3.png";